import { liveStateType } from "../store";

const vod = {
  namespace: true,
  state: {
    activeChannelId: null,
    fullChannelResp: null, //接口/api/v5/channel/unencrypted/list的完整响应
    fullChannelList: [], //完整的频道列表，包含没有权限的
    allChannelList: [], //频道列表，只包含有权限的
    broadcastChannelStatus: false,
  } as liveStateType,
  getters: {
    activeChannelId: (state: liveStateType) => {
      return state.activeChannelId;
    },
    fullChannelList: (state: liveStateType) => {
      return state.fullChannelList;
    },
    allChannelList: (state: liveStateType) => {
      return state.allChannelList;
    },
    broadcastChannelStatus: (state: liveStateType) => {
      return state.broadcastChannelStatus;
    },
  },
  mutations: {
    set_active_channel_id(state: liveStateType, data: any) {
      state.activeChannelId = data;
    },
    setFullChannelResp(state: liveStateType, fullChannelResp: any) {
      state.fullChannelResp = fullChannelResp;
    },
    setFullChannelList(state: liveStateType, fullChannelList: any[]) {
      state.fullChannelList = fullChannelList;
    },
    set_allChannel_list(state: liveStateType, list: any[]) {
      state.allChannelList = list;
    },
    set_broadcast_channel_status(state: liveStateType, status: boolean) {
      state.broadcastChannelStatus = status;
    },
    // 重置 state 为默认值（退出登录时使用）
    resetState(state: liveStateType) {
      state.activeChannelId = null;
      state.fullChannelResp = null;
      state.fullChannelList = [];
      state.allChannelList = [];
      state.broadcastChannelStatus = false;
    },
  },
};

export default vod;
